"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSubjectRefined = void 0;
const buildSubjectRefined = (subject) => ({
    ID: subject.ID,
    metadata: {
        created: subject.metadata.created,
        updated: subject.metadata.updated,
    },
    code: subject.code,
    name: subject.name,
    access: subject.access,
    level: subject.level,
    unspecified: subject.unspecified,
    creditPoints: subject.creditPoints,
    description: subject.description,
    customAttributes: subject.customAttributes,
});
exports.buildSubjectRefined = buildSubjectRefined;
//# sourceMappingURL=SubjectRefined.js.map